import { Place } from '../types/Place'

const places = {
  KARROT: [
    {
      name: '경파',
      x: '127.021572698387',
      y: '37.5029657320399',
    },
    {
      name: '순남시래기',
      x: '127.024812639071',
      y: '37.50234610502',
    },
    {
      name: '인더비엣',
      x: '127.022650362269',
      y: '37.5025591767585',
    },
    {
      name: '멘카오리',
      x: '127.022669504425',
      y: '37.5060226380414',
    },
    {
      name: '버섯매운탕',
      x: '127.021284822335',
      y: '37.5047759043459',
    },
    {
      name: '할랄가이즈',
      x: '127.024645095366',
      y: '37.5018415768539',
    },
    {
      name: '천진영감',
      x: '127.027102001328',
      y: '37.5033331041768',
    },
    {
      name: '연남토마',
      x: '127.026780737254',
      y: '37.5031223421346',
    },
    {
      name: '송화유수',
      x: '127.022999365648',
      y: '37.5047611668821',
    },
    {
      name: '브릭오븐',
      x: '127.027780482342',
      y: '37.5030986851089',
    },
    {
      name: '정돈',
      x: '127.02644174091198',
      y: '37.50393512551716',
    },
  ],
  NBT: [
    {
      name: '서초역',
      x: '126.99932237903495',
      y: '37.4918517000003',
    },
    {
      name: '교대역',
      x: '127.0102111539367',
      y: '37.49390210000001',
    },
    {
      name: '번패티번',
      x: '127.0071469',
      y: '37.4897458',
    },
    {
      name: '샤오짠',
      x: '127.0082748',
      y: '37.4870838',
    },
    {
      name: '김치도가',
      x: '127.0096768',
      y: '37.4897741',
    },
    {
      name: '영양센타',
      x: '127.0048312',
      y: '37.4888882',
    },
    {
      name: '3대삼계장인',
      x: '127.0115182',
      y: '37.491389',
    },
    {
      name: '마제스타시티',
      x: '127.0056469',
      y: '37.4904845',
    },
    {
      name: '함포해장',
      x: '127.0091501',
      y: '37.4896238',
    },
    {
      name: '울트라회관',
      x: '127.0094827',
      y: '37.4907249',
    },
  ],
}

const toPosPlace = (place: { name: string; x: string; y: string }) => {
  return {
    name: place.name,
    lat: Number(place.x),
    lng: Number(place.y),
  }
}

export const getNearPlace = ({
  place,
  groupCode,
}: {
  place: Place
  groupCode: string
}) => {
  const nearPlace = places[groupCode as keyof typeof places]?.find((item) => {
    const meter = calcHaversineMeterDistance({
      pos1: toPosPlace(item),
      pos2: toPosPlace(place),
    })
    return meter <= 20
  })

  return nearPlace?.name
}

export const calcHaversineMeterDistance = ({
  pos1,
  pos2,
}: {
  pos1: { lat: number; lng: number }
  pos2: { lat: number; lng: number }
}) => {
  const R = 6371
  const toRadian = Math.PI / 180
  const dLat = Math.abs(pos2.lat - pos1.lat) * toRadian
  const dLng = Math.abs(pos2.lng - pos1.lng) * toRadian
  const sinDeltaLat = Math.sin(dLat / 2)
  const sinDeltaLng = Math.sin(dLng / 2)
  const squareRoot = Math.sqrt(
    sinDeltaLat * sinDeltaLat +
      Math.cos(pos2.lat * toRadian) *
        Math.cos(pos1.lat * toRadian) *
        sinDeltaLng *
        sinDeltaLng
  )

  const kilometerDistance = 2 * R * Math.asin(squareRoot)
  return kilometerDistance * 1000
}

export const meterToMinutes = (meter: number) => {
  return Math.max(Math.round(meter / 60), 1)
}
